import React, { useRef } from "react";

import Header from "./Header.js";
import Footer from "./Footer.js";

import {
  FaReact,
  FaNodeJs,
  FaPython,
  FaDatabase,
  FaAws,
  FaBrain,
  FaShieldAlt,
  FaMobileAlt,
  FaCloud,
  FaRobot,
  FaCode,
  FaServer,
} from "react-icons/fa";

import {
  SiMongodb,
  SiExpress,
  SiTensorflow,
  SiOpenai,
  SiFirebase,
  SiDocker,
  SiDjango
} from "react-icons/si";

import "./Styles.css";

export default function Technology() {

  const aboutRef = useRef(null);
  const getInTouchRef = useRef(null);

  /* =========================================================
     CORE TECHNOLOGIES
  ========================================================= */

  const coreTechnologies = [

    {
      icon: <FaReact />,
      title: "React.js",
      desc:
        "Modern frontend framework for scalable and fast user interfaces.",
    },

    {
    icon: <FaPython />,
    title: "Python",
    desc:
      "Powerful programming language for AI, automation, and backend systems.",
  },

    {
    icon: <SiDjango />,
    title: "Django",
    desc:
      "High-level Python framework for secure and scalable web applications.",
  },

    {
    icon: <SiMongodb />,
    title: "MongoDB",
    desc:
      "Flexible NoSQL database for high-performance applications.",
  },
  ];

  /* =========================================================
     AI & AUTOMATION
  ========================================================= */

  const aiTechnologies = [

    {
      icon: <FaBrain />,
      title: "Artificial Intelligence",
      desc:
        "Advanced AI systems designed for smart automation and insights.",
    },

    {
      icon: <SiOpenai />,
      title: "OpenAI Integration",
      desc:
        "AI-powered conversational systems and intelligent workflows.",
    },

    {
      icon: <SiTensorflow />,
      title: "TensorFlow",
      desc:
        "Machine learning framework for intelligent AI applications.",
    },

    {
      icon: <FaRobot />,
      title: "Automation Systems",
      desc:
        "Workflow automation solutions powered by AI technologies.",
    },
  ];

  /* =========================================================
     INFRASTRUCTURE
  ========================================================= */

  const infrastructure = [

    {
      icon: <FaAws />,
      title: "AWS Cloud",
      desc:
        "Secure and scalable cloud infrastructure deployment.",
    },

    {
      icon: <FaCloud />,
      title: "Cloud Services",
      desc:
        "High-availability cloud architecture for modern applications.",
    },

    {
      icon: <SiDocker />,
      title: "Docker",
      desc:
        "Containerized deployment environments for scalability.",
    },

    {
      icon: <FaServer />,
      title: "Server Architecture",
      desc:
        "Optimized backend systems for performance and reliability.",
    },
  ];

  /* =========================================================
     SECURITY & MOBILE
  ========================================================= */

  const securityTech = [

    {
      icon: <FaShieldAlt />,
      title: "Cyber Security",
      desc:
        "Enterprise-grade security systems and encrypted infrastructure.",
    },

    {
      icon: <FaMobileAlt />,
      title: "Mobile Development",
      desc:
        "Cross-platform mobile app solutions for Android and iOS.",
    },

    {
      icon: <FaCode />,
      title: "Custom Development",
      desc:
        "Tailored software engineering solutions for businesses.",
    },

    {
      icon: <SiFirebase />,
      title: "Firebase",
      desc:
        "Realtime backend services and cloud integrations.",
    },
  ];

  return (

    <div
      style={{
        background: "#020617",
        minHeight: "100vh",
      }}
    >

      {/* HEADER */}
      <Header
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef
        }}
      />

      {/* PAGE */}
      <div className="products-page">

        {/* =========================================================
           HEADER
        ========================================================= */}

        <div className="products-header">

          <p className="products-tag">
            OUR TECHNOLOGIES
          </p>

          <h1 className="products-title">
            Building the future with modern technologies
          </h1>

          <p className="products-subtitle">
            We leverage cutting-edge technologies, AI systems,
            and scalable cloud infrastructure to create innovative
            digital solutions.
          </p>

        </div>

        {/* =========================================================
           CORE STACK
        ========================================================= */}

        <div className="products-section">

          <h2 className="section-title">
            Core Technologies
          </h2>

          <div className="products-grid">

            {coreTechnologies.map((item, index) => (

              <div
                key={index}
                className="product-card"
              >

                <div className="product-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>

              </div>

            ))}

          </div>

        </div>

        {/* =========================================================
           AI
        ========================================================= */}

        <div className="products-section">

          <h2 className="section-title">
            AI & Automation
          </h2>

          <div className="products-grid">

            {aiTechnologies.map((item, index) => (

              <div
                key={index}
                className="product-card"
              >

                <div className="product-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>

              </div>

            ))}

          </div>

        </div>

        {/* =========================================================
           INFRASTRUCTURE
        ========================================================= */}

        <div className="products-section">

          <h2 className="section-title">
            Infrastructure
          </h2>

          <div className="products-grid">

            {infrastructure.map((item, index) => (

              <div
                key={index}
                className="product-card"
              >

                <div className="product-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>

              </div>

            ))}

          </div>

        </div>

        {/* =========================================================
           SECURITY
        ========================================================= */}

        <div className="products-section">

          <h2 className="section-title">
            Security & Mobile
          </h2>

          <div className="products-grid">

            {securityTech.map((item, index) => (

              <div
                key={index}
                className="product-card"
              >

                <div className="product-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>

              </div>

            ))}

          </div>

        </div>

      </div>

      {/* FOOTER */}
      <Footer
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef
        }}
      />

    </div>
  );
}